import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const PitcairnIslands: Country = {
    identifier: "PitcairnIslands",
    name: "Pitcairn Islands",
    countryCode: "PN",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇵🇳",
    svgPath: "m 114.85075,533.1164 -0.028,0.046 -0.058,-0.039 -0.06,-0.089 -0.023,-0.093 0.056,-0.052 0.075,0.031 0.036,0.096 z",
}
